// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".youtube-video-player {\n  border: 3px solid var(--v-body-60);\n  border-radius: 8px;\n}\n.youtube-video-player.disable-interaction {\n  pointer-events: none;\n}\n.youtube-video-player .play-icon {\n  position: absolute;\n  cursor: pointer;\n  top: 70px;\n  left: 100px;\n  z-index: 10;\n}\n.youtube-video-wrapper {\n  position: relative;\n}", ""]);
// Exports
module.exports = exports;
